<template lang="html">
  <div id="results-page">
    <section class="products-section py-5">
      <div class="container">
        <!-- Header -->
        <div class="text-center mb-4">
          <h1 class="catalog-title mb-3">Búsqueda</h1>
          <p class="lead text-muted mx-auto catalog-subtitle">
            <strong class="f-w-700">Buscar: </strong>{{ $route.query.k }}
          </p>
        </div>

        <!-- Filtros -->
        <div class="mb-4">
          <!-- <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
            <div class="flex-grow-1"></div>
            <button type="button" class="btn btn-outline-secondary btn-sm">
              <i class="fa-solid fa-filter mr-2"></i>
              Filtros
            </button>
          </div> -->

          <!-- Categorías -->
          <div class="d-flex flex-wrap">
            <button type="button" class="btn btn-sm mr-2 mb-2 catalog-filter-btn" :class="filters.category == '' ? 'btn-danger' : 'btn-outline-secondary'" @click="selectedCategory(null)">Todos</button>

            <button
              v-for="(cat, cInx) in categories"
              :key="'cInx-'+cInx"
              type="button"
              class="btn btn-sm mr-2 mb-2 catalog-filter-btn"
              :class="filters.category == cat.id ? 'btn-danger' : 'btn-outline-secondary'"
              @click="selectedCategory(cat.id)"
            >
              {{ cat.name }}
            </button>
          </div>
        </div>

        <!-- Grid de productos -->
        <div class="row" v-if="!isLoading">
          <div
            v-for="product in products"
            :key="product.id"
            class="col-12 col-md-6 col-lg-4 mb-4 box-product-s2"
          >
            <router-link :to="'/producto/'+$root._converToURL(product.name, product.id)" class="text-decoration-none">
              <div class="card border-0 shadow catalog-product-card h-100">
                <div class="position-relative overflow-hidden catalog-product-img-wrap">
                  <img class="w-100 placed-backg" src="public/images/pages/products/product.png" v-bind:style="{ backgroundImage: 'url('+ (product.image ? product.image : 'public/images/pages/products/placeholder.svg') +')' }" />
                  <span class="badge badge-primary catalog-product-badge">{{ product.brand }}</span>
                  <div class="catalog-product-eye">
                    <span class="btn btn-sm btn-light">
                      <i class="fa-solid fa-eye"></i>
                    </span>
                  </div>

                  <div class="position-absolute" style="bottom: 1rem; right: 1rem;">
                    <span class="badge badge-success" v-if="product.stock == true">
                      En Stock
                    </span>
                    <span v-else class="badge badge-secondary">
                      Agotado
                    </span>
                  </div>
                </div>

                <div class="card-body">
                  <h3 class="card-title catalog-product-name mb-2">
                    {{ product.name }}
                  </h3>
                  <p class="text-muted small mb-3 p-short-description">{{ product.short_description }}</p>

                  <div class="d-flex flex-wrap mb-3 box-tags" v-html="$root.generateProdBadge(product.keywords)"></div>

                  <div class="d-flex align-items-center justify-content-between flex-wrap box-bottom">
                    <div class="col col-price">
                      <span class="d-block text-muted small text-decoration-line-through" v-if="product.price_offer">
                        $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} <small>USD</small>
                      </span>
                      <span class="catalog-product-price" v-if="product.price_offer">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_offer) }} <small>USD</small></span>
                      <span class="catalog-product-price" v-else>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} <small>USD</small></span>
                    </div>

                    <div class="col col-button">
                      <button
                        type="button"
                        class="btn btn-danger btn-sm w-100">
                        <i class="fa-solid fa-cart-shopping mr-1"></i>
                        Explorar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-12 col-pagination mt-2" v-if="!isLoading && products.length > 0">
            <b-pagination-nav class="nav-pagination" :link-gen="linkGen" :number-of-pages="totalPages" use-router></b-pagination-nav>
          </div>

          <div v-if="products.length === 0 && !isLoading" class="col-12">
            <div class="alert alert-light text-center py-5">
              No se encontraron productos que coincidan con tu búsqueda.
            </div>
          </div>
        </div>

        <loading-component-s1 v-if="isLoading"></loading-component-s1>

        <!-- CTA -->
        <div class="text-center mt-5">
          <h3 class="h4 font-weight-bold mb-2">¿No encuentras lo que buscas?</h3>
          <p class="text-muted mb-4">Contáctanos para obtener una cotización personalizada</p>
          <router-link to="/contacto" class="btn btn-danger btn-lg">
            Contactar Especialista
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,

      filters: {
        category: null,
        page: 1,
        keywords: '',
      },

      totalPages: 1,
      
      categories: [
        // 'Todos',
        // 'Drones DJI',
      ],
      
      products: [
        // {
        //   id: 1,
        //   name: 'DJI Mavic 3 Enterprise',
        //   category: 'Drones DJI',
        //   price: '4,299.00',
        //   originalPrice: '4,799.00',
        //   image: 'public/images/pages/products/dji-mavic-3-enterprise.jpg',
        //   badge: 'Más Vendido',
        //   badgeVariant: 'badge-danger',
        //   description: 'Drone profesional con cámara 4K y capacidades de inspección avanzadas',
        //   features: ['Cámara 4K', '56 min vuelo', '15km transmisión', 'IP54'],
        // },
      ],
    };
  },

  methods: {
    getProducts: function(){
      this.filters.category = this.$route.query.cat || '';
      this.filters.page = this.$route.query.page || 1;
      this.filters.keywords = this.$route.query.k || '';
      this.isLoading = true;

      axios.post(tools.url('/api/products?page='+this.filters.page), this.filters).then(({data}) =>{
        this.categories = data.categories;
        this.products = data.products.data;
        this.totalPages = data.products.last_page;
        this.isLoading = false;
      });
    },

    linkGen(pageNum) {
      let catID = (this.filters.category == '') ? '' : '='+this.filters.category;

      return pageNum === 1 ? `?k=${this.filters.keywords}&cat${catID}&page=${1}` : `?k=${this.filters.keywords}&cat${catID}&page=${pageNum}`;
    },

    selectedCategory: function(category){
      this.$router.push({ query: { k: this.filters.keywords, cat: category, page: 1 } });
    },
  },

  mounted() {
    this.getProducts();
  },

  watch: {
    $route(to, from) {
      this.getProducts();
    }
  },
};
</script>
